import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AuthModal from '../auth/AuthModal';

const BetaBanner = ({ variant = 'default', onReportIssue }) => {
  const { isAuthenticated } = useAuth();
  const [showSignUpModal, setShowSignUpModal] = useState(false);

  return (
    <>
      <div className="bg-amber-50 border-b border-amber-200 px-4 py-3">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <div className="flex items-start gap-2 flex-1">
            <span className="text-amber-500 flex-shrink-0 mt-0.5" aria-hidden="true">⚠️</span>
            <div className="text-sm text-amber-800">
              <span className="font-semibold">Oko is in Beta</span>
              {' '}— data has not been fully human-reviewed. There may be mistakes.
              {(variant === 'directory') && (
                <span className="block mt-0.5 text-amber-700">
                  If you spot an error in an opportunity, use the Report button on that opportunity's page.
                </span>
              )}
              {(variant === 'directory') && !isAuthenticated && (
                <span className="block mt-1 text-amber-800">
                  Whilst we're testing we're offering a <span className="font-semibold">month free trial</span>.{' '}
                  <button
                    onClick={() => setShowSignUpModal(true)}
                    className="font-semibold underline hover:no-underline focus:outline-none"
                  >
                    Sign up
                  </button>
                </span>
              )}
            </div>
          </div>
          {variant === 'detail' && onReportIssue && (
            <button
              onClick={onReportIssue}
              className="flex-shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-amber-800 bg-amber-100 border border-amber-300 rounded-md hover:bg-amber-200 transition-colors"
            >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
              Report an Issue
            </button>
          )}
        </div>
      </div>
      <AuthModal
        isOpen={showSignUpModal}
        onClose={() => setShowSignUpModal(false)}
        action="get your free month"
      />
    </>
  );
};

export default BetaBanner;
